import React from 'react'

import { connect } from "react-redux"
import { withRouter } from 'react-router'
import sortBy from 'lodash/sortBy'
import {isMobile} from 'react-device-detect';
import backButton from 'browser-back-button';
import loaderImg from '../practice_admin/images/loader.gif'


import * as types from '../../constants/ActionTypes';
import {
    fetchPracticeAvailablePatients,
    fetchPracticePatients,
    practiceAddPatient,
    practiceCreatePatient,
    practicArchivePatient,
    practicUnarchivePatient,
    practiceDeletePatient,
    fetchPatientRecords,
    practiceCreatePatientsByBulkImport
} from "../../actions/practiceAdmin"
import { fetchPractice, setTitle } from "../../actions/index"
import PracticeAdminMenu from './PracticeAdminMenu'
import PatientIcon from './images/PatientIcon'

//import PracticeHeader from '../practice/PracticeHeader'
import PatientDetailsForm from '../admin/PatientDetailsForm'
import PracticePatientRow from './PracticePatientRow'
import SearchIcon from '../../images/icons/SearchIcon'
import TopDrawer from '../ui/TopDrawer'
import BulkImportUpload from '../ui/BulkImportUpload'
import { Tooltip } from 'react-tippy';
import moment from 'moment';
import { isMoment } from 'moment';

import deleteDarkSVG from './images/trash-dark.svg'
import archiveDarkSVG from './images/archive-dark.svg'
import unArchiveDarkSVG from './images/archive-open-dark.svg'
import patientDetailsSVG from './images/profiles.svg'

//import styles
//import './styles/Practice.scss';

@connect((store) => {
    return { User: store.User.User, app: store.app, patients: store.patients }
})
class PracticeAdminPatients extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            draw_open: false,
            new_patient: {},
            add_by: 'select',
            tipOpen: false,
            startDate: moment(),
            sortBy: '',
            search: '',
            loading: true,
            filterBy: 'unarchived',
            fetchingPatients: false,
            patients_records_array: [],
            fetchingPatientRecords: false,
            fetchedPatients: false,
        }
        this.createPatient = this.createPatient.bind(this)
        this.ownerAuth = this.ownerAuth.bind(this);
        this.getPracticePatients = this.getPracticePatients.bind(this)
        this.openClose = this.openClose.bind(this)
        this.handleNewPatientInputChange = this.handleNewPatientInputChange.bind(this)
        this.setAddBy = this.setAddBy.bind(this)
        this.getPracticeAvailablePatients = this.getPracticeAvailablePatients.bind(this)
        this.showTopDrawer = this.showTopDrawer.bind(this);
        this.getPractice = this.getPractice.bind(this);
        this.closeTooltip = this.closeTooltip.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.sortChange = this.sortChange.bind(this);
        this.onSearchChange = this.onSearchChange.bind(this);
        this.actionButtons = this.actionButtons.bind(this);
        this.filterChange = this.filterChange.bind(this);
        this.filterPatients = this.filterPatients.bind(this);
        this.getPatientsRecords = this.getPatientsRecords.bind(this);
        this.fetchRecords = this.fetchRecords.bind(this);
        this.addByFetchForm = this.addByFetchForm.bind(this);
        this.addPatientsByBulkImport = this.addPatientsByBulkImport.bind(this);
    }

    handleChange(date) {
        this.setState({
            'new_patient': { ...this.state.new_patient, ['dob']: date }
        });
        this.setState({
            startDate: date
        });
    }

    sortChange(event) {
        this.setState({ sortBy: event.target.value });
    }

    componentDidUpdate(nextProps) {
        const { dispatch, app, User, params } = this.props
        
        if (User.name == '' && User.name != nextProps.User.name) {
			this.ownerAuth()
		}

        if (User.token && User.name != nextProps.User.name && params.name && app.practice.name == '') {
            this.getPractice();
        }

        if (User.token && !this.props.patients.length && !this.state.fetchedPatients && !this.state.fetchingPatients && this.props.app.practice._id) {
            dispatch(setTitle(`${app.practice.name} patients`))
            this.getPracticePatients();

            if (this.state.draw_open && this.state.add_by === 'select') {
                this.getPracticeAvailablePatients()
            }

            this.props.dispatch({
                type: types.SET_APP_PRACTICE_FIELD,
                payload: {
                    key: 'needsData',
                    val: false
                }
            });
        }   
    }

    closeTooltip() {
        const seenPatientsList = window.localStorage.getItem('seen-patients-list') || 0;

        window.localStorage.setItem('seen-patients-list', (seenPatientsList / 1) + 1)
        this.setState({
            'tipOpen': false
        })
    }

    componentWillUnmount() {
        const { tipOpen } = this.state;
        tipOpen && this.closeTooltip()
    }

    getPractice() {
        const { params, dispatch } = this.props
        return dispatch(fetchPractice(params.name))
    }

    componentWillMount() {
        this.props.dispatch({ type: types.SET_PATIENTS, payload: [] });
        this.props.dispatch({
            type: types.SET_APP_PRACTICE_FIELD,
            payload: {
                key: 'needsData',
                val: true
            }
        });
    }

    onSearchChange(event) {
        this.setState({ search: event.target.value });
    }

    componentDidMount() {
        let seenPatientsList = window.localStorage.getItem('seen-patients-list') || 0
        if (!this.props.patients.length) {
            this.setState({
                'tipOpen': 'add-patients'
            })
            return
        }
        if ((seenPatientsList / 1) < 3) {
            this.setState({
                'tipOpen': 'connections'
            })
        }

        //Go back on back button press
        backButton.on(()=>{
            this.props.history.push('/practice_admin/')
            this.props.history.goBack()
        });
    }

    unaddedParentsChildren() { }

    createPatient(e) {
        e.preventDefault()
        let u = this.state.new_patient;
        // mark as created by this practice
        u.createdBy = this.props.app.practice._id;
        this.props.dispatch(practiceCreatePatient(this.props.app.practice._id, u))

        this.openClose()
        this.setState({
            "new_patient": {
                "firstName": '',
                "middleNames": '',
                "lastName": '',
                "dob": ''
            }
        })

        if (window.localStorage.getItem('seen-patients-list') / 1 < 4) {
            this.setState({
                "tipOpen": "connections"
            })

        }
    }

    addPatient(patient) {
        this.props.dispatch(practiceAddPatient(this.props.app.practice._id, patient))
            .then(() => {
                this.setState({
                    tipOpen: "connections"
                })
            })
        this.openClose()
    }

    handleNewPatientInputChange(e, att) {
        const { new_patient } = this.state;
        this.setState({
            "new_patient": {
                ...new_patient,
                [att]: e.target.value
            }
        })
    }

    openClose() {
        this.setState({
            draw_open: !this.state.draw_open
        });
        if (this.state.add_by === 'select') {
            this.getPracticeAvailablePatients()
        }
    }

    setAddBy(val) {
        if (val === 'select') {
            this.getPracticeAvailablePatients()
        }
        this.setState({ "add_by": val })
    }

    isParent(userId) {
        return this.props.app.practice.parents.indexOf(userId) > -1;
    }

    isTherapist(userId) {
        return this.props.app.practice.therapists
            ? this.props.app.practice.therapists.indexOf(userId) > -1
            : false;
    }

    getPracticePatients() {
        let {
            patients_records_array
        } = this.state;
        let self = this;
        // console.log('Get Patients.');
        this.setState({
            fetchingPatients: true
        });
        this.props.dispatch(fetchPracticePatients(this.props.app.practice._id))
            .then(action => {
                // console.log(action.payload);
                this.setState({
                    fetchingPatients: false,
                    loading: false,
                    fetchedPatients: true
                });

                if (action.payload) {
                    if (!action.payload.length) {
                        this.setState({
                            "add_by": "manually",
                            "draw_open": true,
                        })
                    } else {
                        // this.getPatientsRecords(action.payload);
                        action.payload.forEach(function (patient) {
                            // console.log(patient);
                            self.props.dispatch(fetchPatientRecords(patient._id))
                                .then((d) => {
                                    patients_records_array[patient._id] = d;
                                    self.setState({
                                        "patients_records_array": patients_records_array
                                    });
                                })
                        });

                    }
                }
            })
    }

    getPatientsRecords(patients) {
        console.log(this.state);
        patients.forEach(function(patient) {
            console.log(patient);
            this.fetchRecords(patient);
        });
    }

    fetchRecords(patient) {
        let { patients_records_array } = this.state;
        this.props.dispatch(fetchPatientRecords(patient._id))
            .then((d) => {
                patients_records_array[patient._id] = d;
                this.setState({
                    "patients_records_array": patients_records_array
                });
                // return d;
            })
    }

    getPracticeAvailablePatients() {
        this.props.dispatch(fetchPracticeAvailablePatients(this.props.app.practice._id))
            .then(action => {
                if (action.payload) {
                    if (!action.payload.length) {
                        this.setState({
                            "add_by": "manually"
                        })
                    }
                }

            })
    }

    addPatientImage() {
        return <div className="add-patient-icon">
            {/* <PatientIcon/> */}
            <span>+</span>
        </div>
    }

    addPatientsByBulkImport(doc) {
        const self = this;
		this.props.dispatch(practiceCreatePatientsByBulkImport(this.props.app.practice._id,
			{
				document: doc
			}))
			.then(r => {
				console.log('Create new patients by bulk import')
				// eslint-disable-next-line
                console.log(r);
                self.getPracticePatients();
                self.openClose();
			});
	}

    addByFetchForm() {
        const { new_patient, add_by, startDate } = this.state;
        const { availablePatients } = this.props.app.practice

        if (add_by === 'manually') {
            return <PatientDetailsForm
                handleInputChange={this.handleNewPatientInputChange}
                patient={new_patient}
                startDate={startDate}
                handleChange={(date) => {
                    this.handleChange(date)
                }}
                handleSubmit={this.createPatient} />
        } else if (add_by === 'bulk') {
            return <BulkImportUpload 
                callback={this.addPatientsByBulkImport} 
                path={`documents/practice/${this.props.app.practice._id}/patients/bulk/`} />
        } else {
          return <div>
                    {availablePatients && availablePatients.length
                        ? null
                        : <p>No patients to add automatically</p>
                    }

                    <br />
                    <ul className="md-list small">
                        {
                            availablePatients && availablePatients.map(patient => (patient &&
                                <li
                                    key={`available-patients-${patient._id}`}
                                    onClick={() => this.addPatient(patient)} className="row">
                                    <div className="md-subhead row-content">
                                        {patient.firstName}
                                        {patient.lastName}
                                        <div className="md-body-2">
                                            Parent: {patient.parent.name}
                                        </div>
                                    </div>
                                </li>))
                        }
                    </ul>
                </div>
        }
    }

    showTopDrawer() {
        const { new_patient, add_by, startDate } = this.state;
        const { availablePatients } = this.props.app.practice

        return (<TopDrawer image={this.addPatientImage()} open={this.state.draw_open} openClose={this.openClose}>
            <div className="row center addPatientDrawer _jsLoader">
                <div>
                    <div className={"padding manualButton " + (add_by === 'manually' && "link active")} onClick={() => this.setAddBy('manually')}>Add Patient Manually</div>
                    { !isMobile ? <div className={"padding bulkButton " + (add_by === 'bulk' && "link active")} onClick={() => this.setAddBy('bulk')}>Bulk Import Patients</div> : '' }
                </div>
                {availablePatients && !availablePatients.length ? null : <div className="padding">&middot;</div>}
                {availablePatients && !availablePatients.length ? null : (
                    <div>
                        <div className={add_by === 'select' && "link active"} onClick={() => this.setAddBy('select')}>Select users</div>
                    </div>
                )}
            </div>
            { this.addByFetchForm() }
        </TopDrawer>)
    }

    ownerAuth() {
        const { app, User, params, router } = this.props;
        // is this not an owner of this practice?

        if (!app.authed) return false;

        if (!User.ownPractices
            .find(p => params.name === p.id || params.name === p.slug)) {
            router && router.push('/');
            return false
        }
        return true
    }

    deletePatient(patient) {
        console.log('Delete Patient');
        console.log(patient);
        this.props.dispatch(practiceDeletePatient(this.props.app.practice._id, patient._id))
            .then(() => {
                console.log('Deleted Patient');
                this.getPracticePatients();
            })
    }

    archivePatient(patient) {
        // console.log('Archive Patient');
        // console.log(patient);
        if (patient.archived) {
            // console.log('Unarchive');
            this.props.dispatch(practicUnarchivePatient(this.props.app.practice._id, patient._id))
                .then(() => {
                    console.log('Unarchived patient');
                    this.getPracticePatients();
                });
        } else {
            // console.log('Archive');
            // get patients
            this.props.dispatch(practicArchivePatient(this.props.app.practice._id, patient._id))
                .then(() => {
                    console.log('Archived patient');
                    this.getPracticePatients();
                })
        }
    }

    actionButtons(patient) {
        // console.log(patient);
        // console.log(this.props);
        // this.setState({
        //     'patient_records_array': []
        // });
        // console.log(this.state.patients_records_array);
        let actionBtn = null;
        // if (!this.state.fetchingPatientRecords) {
        //     if (this.getPatientRecords(patient)) {
                if (
                    ((patient.guardians !== undefined) && (patient.guardians.length > 0)) || 
                    ((patient.parent !== null) && (patient.parent !== undefined)) || 
                    ((patient.therapists !== undefined) && (patient.therapists.length > 0)) ||
                    ((patient.therapy_areas !== undefined) && (patient.therapy_areas.length > 0)) ||
                    ((this.state.patients_records_array.length > 0) && (this.state.patients_records_array[patient._id]))
                ) {
                    if (patient.archived) {
                        /* This should be set to unarchived */
                        actionBtn = (<a onClick={() => { 
                            let confirm = window.confirm('Are you sure you want unarchive this patient?')
                            confirm ? this.archivePatient(patient) : ''
                        }} >
                            <img className="unArchiveDarkSVG" src={unArchiveDarkSVG} />
                        </a>);
                    } else {
                        /* This should be set to archived */
                        actionBtn = (<a onClick={() => { 
                            let confirm = window.confirm('Are you sure you want archive this patient?')
                            confirm ? this.archivePatient(patient) : ''
                        }} >
                            <img className="archiveDarkSVG" src={archiveDarkSVG} />
                        </a>);
                    }
                } else {
                    /* This should be set to delete */
                    actionBtn = (<a onClick={() => { 
                        let confirm = window.confirm('Are you sure you want delete this patient?')
                        confirm ? this.deletePatient(patient) : ''
                    }} >
                        <img src={deleteDarkSVG} />
                    </a>);
                }
        //     }
        // }
        
        return (<div className="patientViewButtons">
            <div className="patientViewDetails">
                <a href={`/practice_admin/${this.props.params.name}/patients/${patient._id}/history`}>
                    <img src={patientDetailsSVG}/>
                </a>
            </div>
            <div className="buttons">
                {actionBtn}
            </div>
        </div>)
    }

    filterChange(event) {
        console.log(event.target.value);
        this.setState({ filterBy: event.target.value });
    }

    filterPatients(patients) {
        let { filterBy } = this.state;
        let users = [];
        // console.log(filterBy);
        // console.log(patients);
        patients.forEach(patient => {
            // console.log(patient);
            if (filterBy === 'all') {
                users.push(patient);
            } else if (filterBy === 'archived' && patient.archived) {
                users.push(patient);
            } else if (filterBy === 'unarchived' && !patient.archived) {
                users.push(patient);
            }
        });

        return users;
    }

    render() {
        const { params } = this.props;
        const { tipOpen, loading } = this.state

        let _users = this.filterPatients(this.props.patients);

        if (loading) {
			const divStyle = {
				'paddingTop': '50px',
				'fontSize': '.4em',
				'position': 'fixed',
				'transform': 'translate(-50%, -50%)',
				'top': '40%',
				'left': '50%',
				'display': 'flex',
				'flexDirection': 'column',
				'alignItems': 'center',
				'justifyContent': 'center'
			};
			
			// Need to style loading
			return (<div>
				<main className={"main"}>
					<div className="padding">
						<h4 style={divStyle}>
							<img src={loaderImg} alt=""/>
							<small>Loading</small>
						</h4>
					</div>
				</main>
			</div>);
		}

        if (this.state.search.length > 0) {
            let search = this.state.search;
            const s = new RegExp(`^${search.trim().toLowerCase()}`, 'gi')

            _users = _users.filter(function (user) {
                let fname = user.firstName + ' ' + user.middleNames + ' ' + user.lastName;
                return fname.toLowerCase().match(s);
            });
        }

         return (<main className="main practice-page hello">
            {this.showTopDrawer()}
            <PracticeAdminMenu active="patients" params={params} />
            <div className="page heigth110 mb8">

                <div>
                    <div className="search-box__content">
                        <div className="search-box__input">
                            <SearchIcon />
                            <input type="search" onChange={this.onSearchChange} value={this.state.search} placeholder="Search for Patients" />
                        </div>
                    </div>
                </div>
                <div className="filterRow">
                    Filter By:
                <select value={this.state.filterBy} onChange={this.filterChange}>
                        <option value="unarchived">Active</option>
                        <option value="all">All</option>
                        <option value="archived">Archived</option>
                    </select>
                    Sort By:
                <select value={this.state.sortBy} onChange={this.sortChange}>
                        <option value="name">Name</option>
                        <option value="created">Date</option>
                    </select>
                </div>
                <Tooltip
                    style={{ position: "absolute", top: "-10px", right: "28px", display: "block" }}
                    title="Add patients here"
                    open={tipOpen === "add-patients"}
                    trigger="manual"
                    position="bottom"
                    arrow={true}
                    size="big"
                    hideDelay={4}
					duration={1000}
                    sticky={true}
                    unmountHTMLWhenHide={true}
                    onRequestClose={() => { this.closeTooltip() }}>
                    <div className="right" style={{ margin: "20px 20px 0 0" }} ></div>
                </Tooltip>

                <Tooltip
                    className="md-list"
                    title="Let's make connections! Click a patient to link them with parents and therapists"
                    open={tipOpen === "connections"}
                    trigger="manual"
                    position="top"
                    arrow={true}
                    size="big"
                    hideDelay={4}
					duration={1000}
                    unmountHTMLWhenHide={true}
                    onRequestClose={() => { this.closeTooltip() }}
                >
                    <div>&nbsp;</div>
                </Tooltip>

                <div ref="content">
                    <ul className="md-list">
                        {sortBy(_users, [((this.state.sortBy == 'created') ? (this.state.sortBy) : (p => {
                            if (!p.firstName) return !p.firstName // no firstNames are pushed to the end
                            return p.firstName.toLowerCase()
                        }))])
                            .map(patient => <PracticePatientRow
                                to={`/practice_admin/${this.props.params.name}/patients/${patient._id}`}
                                key={`patient-${patient._id}`}
                                patient={patient}
                                actionButtons={this.actionButtons} />
                            )}
                    </ul>
                </div>
            </div></main>)
    }
}

class ChildOption extends React.Component {
    propTypes: {
        name: React.PropTypes.string,
        value: React.PropTypes.string,
    };

    render() {
        return (
            <option value={this.props.value}>{this.props.name}</option>
        )
    }
}

export default withRouter(PracticeAdminPatients);



// WEBPACK FOOTER //
// ./src/components/practice_admin/PracticeAdminPatients.jsx